{
  "ragai": [
    {
      "name": "Extras",
      "data": [
        {
          "method": "confetti()",
          "description": "Bereitstellung der canvas-confetti API.",
          "code": "RAGAI.confetti();\n"
        },
        {
          "method": "cancel()",
          "description": "Bricht den aktuellen Denkprozess des Bots ab.",
          "code": "await RAGAI.cancel();\n"
        },
        {
          "method": "chance()",
          "description": "Bereitstellung der chance API.",
          "code": "RAGAI.chance();\n"
        },
        {
          "method": "qs",
          "description": "Bereitstellung der queryString API.",
          "code": "RAGAI.qs;\n"
        },
        {
          "method": "resetBot()",
          "description": "Setzt den Bot für den Nutzer zurück.",
          "code": "await RAGAI.resetBot();\n"
        },
        {
          "method": "service",
          "description": "Gibt die RAGAI-Instanz zurück.",
          "code": "RAGAI.service;\n"
        },
        {
          "method": "loggedInUser",
          "description": "Gibt den aktuell eingeloggten Nutzer zurück.",
          "code": "const user = RAGAI.loggedInUser;\nconst user_metadata = RAGAI.loggedInUser.metadata;\nconst user_guestId = RAGAI.loggedInUser.guestId;\n"
        },
        {
          "method": "restartBot()",
          "description": "Startet den Bot neu.",
          "code": "await RAGAI.restartBot();\n"
        }
      ]
    },
    {
      "name": "aiimage_openai",
      "data": [
        {
          "method": "create('prompt')",
          "description": "Sendet einen Prompt an die KI, die daraufhin ein Bild generiert.",
          "code": "await RAGAI.AIIMAGE_OPENAI.create('A cat with hat');\n"
        },
        {
          "method": "getImageUrl('_id')",
          "description": "Gibt die URL zu einem generierten Bild zurück.",
          "code": "RAGAI.AIIMAGE_OPENAI.getImageUrl('161259a07c5feee0a13126');\n"
        },
        {
          "method": "analyzeImage('image', 'prompt')",
          "description": "Ermöglicht es, ein Bild anhand einer URL oder eines Base64-Strings basierend auf dem gegebenen Prompt zu analysieren.",
          "code": "await RAGAI.AIIMAGE_OPENAI.analyzeImage('https://meinewebseite.de/einbild.jpg', 'Was ist auf dem Bild zu sehen?')\n"
        }
      ]
    },
    {
      "name": "aiimage_stablediffusion",
      "data": [
        {
          "method": "create('prompt')",
          "description": "Sendet einen Prompt an die KI, die daraufhin ein Bild generiert.",
          "code": "await RAGAI.AIIMAGE_STABLEDIFFUSION.create('A raccoon skating');\n"
        },
        {
          "method": "getImageUrl('_id')",
          "description": "Gibt die URL zu einem generierten Bild zurück.",
          "code": "RAGAI.AIIMAGE_STABLEDIFFUSION.getImageUrl('131259a161c5feee0a1681793');\n"
        }
      ]
    },
    {
      "name": "aitext_vllm",
      "data": [
        {
          "method": "chatCompletion('prompt')",
          "description": "Sendet einen Prompt an die KI, der unabhängig vom geöffneten Bot ausgeführt wird.",
          "code": "await RAGAI.AITEXT_VLLM.chatCompletion('Give me some ice');\n"
        },
        {
          "method": "chatCompletionJson('prompt')",
          "description": "Sendet einen Prompt an die KI, der unabhängig vom geöffneten Bot ausgeführt wird und ein JSON zurückgibt.",
          "code": "await RAGAI.AITEXT_VLLM.chatCompletionJson('Talk to me nicely');\n"
        }
      ]
    },
    {
      "name": "aitext_openai",
      "data": [
        {
          "method": "chatCompletion('prompt', 'model', Temperatur)",
          "description": "Sendet einen Prompt an die KI, der unabhängig vom geöffneten Bot ausgeführt wird.",
          "code": "await RAGAI.AITEXT_OPENAI.chatCompletion('Give me some ice', 'gpt-5', 0.7);\n"
        },
        {
          "method": "chatCompletionJson('prompt', 'model', Temperatur)",
          "description": "Sendet einen Prompt an die KI, der unabhängig vom geöffneten Bot ausgeführt wird und ein JSON zurückgibt.",
          "code": "await RAGAI.AITEXT_OPENAI.chatCompletionJson('Talk to me nicely', 'gpt-5', 0.7);\n"
        },
        {
          "method": "getImageMessageContent('source')",
          "description": "Erstellt ein Nachrichtenobjekt für ein Bild, basierend auf einer Bildquelle.",
          "code": "await RAGAI.AITEXT_OPENAI.getImageMessageContent('url_zum_bild.png' oder 'skillId')\n"
        }
      ]
    },
    {
      "name": "audio",
      "data": [
        {
          "method": "say('text', 'voice')",
          "description": "Lässt den eingegebenen Text von einer ausgewählten Stimme vorlesen.",
          "code": "await RAGAI.AUDIO.say('Guten Tag', 'Nicole');\n"
        },
        {
          "method": "setText('text')",
          "description": "Tauscht bei dem Audio-Bot den '*ich höre*' Text mit der Eingabe aus.",
          "code": "RAGAI.AUDIO.setText('text')\n"
        },
        {
          "method": "isMicMuted()",
          "description": "Abfrage, ob das Mikrofon des Nutzers stumm geschaltet ist.",
          "code": "RAGAI.AUDIO.isMicMuted();\n"
        },
        {
          "method": "unmuteMic()",
          "description": "Löst die Stummschaltung des Mikrofons des Nutzers auf.",
          "code": "RAGAI.AUDIO.unmuteMic();\n"
        },
        {
          "method": "muteMic()",
          "description": "Setzt das Mikrofon des Nutzers auf stumm",
          "code": "RAGAI.AUDIO.muteMic();\n"
        },
        {
          "method": "setInstruction('text')",
          "description": "Definiert eine Betonungsanweisung für den Audiobot, die ab der nächsten Sprachausgabe greift.",
          "code": "RAGAI.AUDIO.setInstruction('text');\n"
        },
        {
          "method": "getInstruction()",
          "description": "Gibt die aktuell gesetzte Betonungsanweisung des Audiobots zurück.",
          "code": "await RAGAI.AUDIO.getInstruction();\n"
        },
        {
          "method": "stopSpeaking()",
          "description": "Bricht die Sprachausgabe des Bots ab.",
          "code": "RAGAI.AUDIO.stopSpeaking();\n"
        },
        {
          "method": "botSay('text', 'voice')",
          "description": "Lässt den eingegebenen Text von einer ausgewählten Stimme vorlesen.",
          "code": "await RAGAI.AUDIO.botSay('Challenge akzeptiert', 'Lily');\n"
        }
      ]
    },
    {
      "name": "beforesend",
      "data": [
        {
          "method": "add(msg_function)",
          "description": "Registriert eine neue Funktion zur Nachrichtenverarbeitung.",
          "code": "RAGAI.BEFORE_SEND.add((msg) => { return msg.replaceAll(' ', '_')});\n"
        },
        {
          "method": "run(text)",
          "description": "Führt alle registrierten Funktionen aus und gibt das modifizierte Ergebnis zurück.",
          "code": "RAGAI.BEFORE_SEND.run('Meine tolle Nachricht an den Bot');\n"
        },
        {
          "method": "clear()",
          "description": "Entfernt alle registrierten Funktionen.",
          "code": "RAGAI.BEFORE_SEND.clear();\n"
        },
        {
          "method": "list()",
          "description": "Gibt die aktuell registrierten Funktionen zurück (z. B. zu Debug-Zwecken).",
          "code": "RAGAI.BEFORE_SEND.list();\n"
        }
      ]
    },
    {
      "name": "cards",
      "data": [
        {
          "method": "image('url', cssClass)",
          "description": "Zeigt ein Bild direkt im Chatverlauf an.",
          "code": "await RAGAI.CARDS.image('url_zum_bild.png');\n"
        },
        {
          "method": "iframe('url', cssClass)",
          "description": "Zeigt eine eingebettete Website als iFrame direkt im Chatverlauf an.",
          "code": "await RAGAI.CARDS.iframe('https://..... ');\n"
        },
        {
          "method": "vimeo('id', 'hash', cssClass)",
          "description": "Zeigt ein Vimeo-Video direkt im Chatverlauf an. Benötigt werden die Video-ID und der generierte Freigabe-Hash.",
          "code": "await RAGAI.CARDS.vimeo('id','hash');\n"
        },
        {
          "method": "youtube('video_id', cssClass)",
          "description": "Zeigt ein YouTube-Video direkt im Chatverlauf an.",
          "code": "await RAGAI.CARDS.youtube('YOUTUBE_VIDEO_ID');\n"
        },
        {
          "method": "buttons(buttons[], cssClass)",
          "description": "Zeigt eine Reihe von Buttons direkt im Chatverlauf an.",
          "code": "await RAGAI.CARDS.buttons(['Button1', { text: 'Button2', className: '', onClick: 'button2Func()'}]);\n"
        },
        {
          "method": "stageListButtons()",
          "description": "Stellt die eingestellten Stages als Buttons im Chatverlauf dar.",
          "code": "await RAGAI.CARDS.stageListButtons();\n"
        },
        {
          "method": "html('html', cssClass)",
          "description": "Zeigt übergebenen HTML-Code direkt im Chatverlauf an.",
          "code": "await RAGAI.CARDS.html('<h1>HTML INPUT</h1>');\n"
        },
        {
          "method": "loading('text', remixIcon, cssClass)",
          "description": "Zeigt eine temporäre Nachricht im Chatverlauf an.",
          "code": "await RAGAI.CARDS.loading('Bitte warten');\n"
        },
        {
          "method": "removeLoading()",
          "description": "Entfernt die temporäre Ladenachricht im Chat.",
          "code": "await RAGAI.CARDS.removeLoading();\n"
        }
      ]
    },
    {
      "name": "charts",
      "data": [
        {
          "method": "radar(values[],labels[])",
          "description": "Erstellt ein Radar-Chart (auch bekannt als Spinnennetz-Diagramm) mit den angegebenen Werten und Achsenbeschriftungen.",
          "code": "RAGAI.CHARTS.radar([0,2,3,5,6], ['Achse A ','Achse B','Achse C','Achse D','Achse E']);\n"
        }
      ]
    },
    {
      "name": "chat_avatar",
      "data": [
        {
          "method": "setBotImg('skillId')",
          "description": "Setzt anhand der übergebenen Skill-ID das Avatar-Bild für den Bot im Chat.",
          "code": "await RAGAI.CHAT_AVATAR.setBotImg('botImg');\n"
        },
        {
          "method": "setUserImg('skillId')",
          "description": "Setzt anhand der übergebenen Skill-ID das Avatar-Bild für den User im Chat.",
          "code": "await RAGAI.CHAT_AVATAR.setUserImg('userImg');\n"
        },
        {
          "method": "unsetBotImg()",
          "description": "Entfernt das gesetzte Avatar-Bild für den Bot im Chat.",
          "code": "await RAGAI.CHAT_AVATAR.unsetBotImg();\n"
        },
        {
          "method": "unsetUserImg()",
          "description": "Entfernt das gesetzte Avatar-Bild für den User im Chat.",
          "code": "await RAGAI.CHAT_AVATAR.unsetUserImg();\n"
        }
      ]
    },
    {
      "name": "dialogStore",
      "data": [
        {
          "method": "getCurrentDialog()",
          "description": "Holt den Chatverlauf des aktuellen Chats.",
          "code": "RAGAI.DIALOGSTORE.getCurrentDialog();\n"
        }
      ]
    },
    {
      "name": "docsearch",
      "data": [
        {
          "method": "apiToken",
          "description": "Gültiger API-Token des angegebenen DocSearch-Servers.",
          "code": "RAGAI.DOCSEARCH.apiToken = '';\n``` -->\n\n## .beforeItemHtml\n\nGrundgerüst der Dokumentenliste.\n\n```javascript\nRAGAI.DOCSEARCH.beforeItemHtml = <div class='list-group me-3'>;\n"
        },
        {
          "method": "itemHtml",
          "description": "HTML des einzelnen Listeneintrages.",
          "code": "RAGAI.DOCSEARCH.itemHtml = `\n<a class='list-group-item list-group-item-action docsearch-link' href='{{url}}'>\n    <i class='ri-file-pdf-2-fill'></i>\n    <strong>{{filename}}</strong><br>\n    <small>{{title}}</small>\n  </a>\n`;\n"
        },
        {
          "method": "afterItemHtml",
          "description": "Grundgerüst der Dokumentenliste.",
          "code": "RAGAI.DOCSEARCH.afterItemHtml = '</div>';\n"
        },
        {
          "method": "clickFn('url')",
          "description": "Stellt eine Klick-Funktion bereit, um das Suchergebnis in einem IFrame-Overlay anzuzeigen.",
          "code": "RAGAI.DOCSEARCH.clickFn('URL zum Suchergebnis vom DocSearch-Servers');\n"
        },
        {
          "method": "searchAsJson('query', 'count' = 5)",
          "description": "Führt die Suche anhand eines Suchtexts mit optionaler Begrenzung der Ergebnisse durch.",
          "code": "const data = await RAGAI.DOCSEARCH.searchAsJson('Blumen', 8);\n"
        },
        {
          "method": "jsonToHtml('data')",
          "description": "Konstruiert die Ergebnisliste aus dem Ergebnis von searchAsJson() und den Variablen beforeItemHtml, itemHtml und afterItemHtml.",
          "code": "RAGAI.DOCSEARCH.jsonToHtml();\n"
        },
        {
          "method": "searchAsCard('query', 'count' = 5)",
          "description": "Führt eine Dokumentensuche auf Basis des Suchtextes durch und stellt das Ergebnis in einer Ergebnistabelle dar.",
          "code": "await RAGAI.DOCSEARCH.searchAsCard('Blumen', 8);\n"
        }
      ]
    },
    {
      "name": "dom",
      "data": [
        {
          "method": "body()",
          "description": "Gibt das HTML-Element des Bot-Containers zurück.",
          "code": "RAGAI.DOM.body();\n"
        },
        {
          "method": "header()",
          "description": "Gibt das HTML-Element des Bot-Headers zurück.",
          "code": "RAGAI.DOM.header();\n"
        },
        {
          "method": "content()",
          "description": "Gibt das HTML-Element des Bot-Contents zurück.",
          "code": "RAGAI.DOM.content();\n"
        },
        {
          "method": "footer()",
          "description": "Gibt das HTML-Element des Bot-Footers zurück.",
          "code": "RAGAI.DOM.footer();\n"
        },
        {
          "method": "hideFooter()",
          "description": "Blendet den Footer aus.",
          "code": "RAGAI.DOM.hideFooter();\n"
        },
        {
          "method": "showFooter()",
          "description": "Blendet den Footer ein.",
          "code": "RAGAI.DOM.showFooter();\n"
        },
        {
          "method": "hideHeader()",
          "description": "Blendet den Header aus.",
          "code": "RAGAI.DOM.hideHeader();\n"
        },
        {
          "method": "showHeader()",
          "description": "Blendet den Header ein.",
          "code": "RAGAI.DOM.showHeader();\n"
        },
        {
          "method": "createElementFromHTML('html')",
          "description": "Erstellt ein DIV-Element mit dem übergebenen HTML-Inhalt.",
          "code": "RAGAI.DOM.createElementFromHTML('<h1>Das wird zu einem DIV</h1>');\n"
        },
        {
          "method": "setBodyColor('color')",
          "description": "Setzt die Hintergrundfarbe des Containers mit der ID 'bot-container' auf die übergebene Farbe.",
          "code": "RAGAI.DOM.setBodyColor('red');\n"
        }
      ]
    },
    {
      "name": "download",
      "data": [
        {
          "method": "textAsFile('text', 'filename')",
          "description": "Lädt Text als Datei herunter.",
          "code": "RAGAI.DOWNLOAD.textAsFile('Lorem Ipsum', 'exampleFile');\n"
        },
        {
          "method": "downloadMaterial('skillId')",
          "description": "Lädt Material aus Dokumenten herunter.",
          "code": "await RAGAI.DOWNLOAD.downloadMaterial('skillId');\n"
        },
        {
          "method": "getMDContent('skillId')",
          "description": "Lädt und gibt das MD eines Dokumentes zurück im JSON-Format.",
          "code": "await RAGAI.DOWNLOAD.getMDContent('skillId');\n"
        }
      ]
    },
    {
      "name": "events",
      "data": [
        {
          "method": "addEventHook('my_custom_hook_name_specific_hook',fn, 'hookName')",
          "description": "Registriert einen benennbaren Listener (auch Handler oder Callback), um auf Events der Engine zu reagieren.",
          "code": "RAGAI.EVENTS.addEventHook('my_custom_hook_name_specific_hook', function(content) {\n  // hookName z.b. 'runComplete'\n\n}, 'hookName');\n"
        },
        {
          "method": "addEventHookAddUserMessage('my_custom_hook_name_addUserMessage',fn)",
          "description": "Registriert einen Listener, um auf Nutzereingaben im Bot zu reagieren.",
          "code": "RAGAI.EVENTS.addEventHookAddUserMessage('my_custom_hook_name_addUserMessage', function(message) {\n  /*\n  INFO\n  console.log('Run Update message ist  ', message )\n */\n});\n"
        },
        {
          "method": "removeEventHook('custom_hook_name')",
          "description": "Entfernt einen zuvor registrierten Listener.",
          "code": "RAGAI.EVENTS.removeEventHook('my_custom_ook_name_*');\n"
        },
        {
          "method": "triggerEventHook('custom_hook_name', [])",
          "description": "Löst gezielt ein Event aus. Dabei lassen sich sowohl systemeigene (bot-interne) Events als auch frei definierte, benutzerdefinierte Events anstoßen.",
          "code": "RAGAI.EVENTS.triggerEventHook('my_custom_hook_name_triggerEvent', []);\n"
        },
        {
          "method": "inActiveHook(sec)",
          "description": "Definiert einen zeitgesteuerten Hook, der nach einer festgelegten Dauer der Inaktivität automatisch ausgelöst wird. Der Rückgabewert `count` gibt an, die wievielte Ausführung des Hooks gerade erfolgt.",
          "code": "var myHook = RAGAI.EVENTS.inActiveHook(45);\nmyHook.action = function(count){}\n"
        },
        {
          "method": "listenTo(eventName, fn)",
          "description": "",
          "code": "public listenTo(eventName, async function(e){\n//\n});\n"
        }
      ]
    },
    {
      "name": "fusionview",
      "data": [
        {
          "method": "goToFusionView(fusionViewId)",
          "description": "Schaltet die Ansicht von der aktuellen Fusion auf eine andere, im Bot vorhandenen Fusion-View um.",
          "code": "RAGAI.FUSIONVIEW.goToFusionView('66fa4fbadbb81c2a345602b3');\n"
        }
      ]
    },
    {
      "name": "helper",
      "data": [
        {
          "method": "addStat('stat')",
          "description": "Fügt einen Messpunkt hinzu.",
          "code": "await RAGAI.HELPER.addStat('Kontaktdaten erfragt');\n"
        },
        {
          "method": "copyToClipboard('text')",
          "description": "Legt einen übergebenen Text in die Zwischenablage des Bot-Nutzers.",
          "code": "RAGAI.HELPER.copyToClipboard('Text zum kopieren');\n"
        },
        {
          "method": "closeWindow()",
          "description": "Schließt das aktuelle Fenster im Browser.",
          "code": "RAGAI.HELPER.closeWindow();\n"
        },
        {
          "method": "getImageURLFromSkill('skillId')",
          "description": "Liefert einen Link zum Abruf der im Bot vorhandenen Bilddatei auf Basis der Skill-ID.",
          "code": "await RAGAI.HELPER.getImageURLFromSkill('ChatBotAvatarImg');\n"
        },
        {
          "method": "endBot(opts)",
          "description": "Die Kommunikation mit dem Bot wird beendet. Es können optionale Eigenschaften mitgegeben werden.",
          "code": "RAGAI.HELPER.endBot({\n  autoRedirectSeconds: 0,\n  redirectUrl: '',\n  redirectTitle: '',\n  title: '',\n  message: '',\n  restartUrl: ''\n});\n"
        },
        {
          "method": "timeToSeconds(hours, minutes, seconds)",
          "description": "Rechnet Stunden, Minuten und Sekunden in Sekunden um.",
          "code": "RAGAI.HELPER.timeToSeconds(3, 34, 28)\n"
        }
      ]
    },
    {
      "name": "info",
      "data": [
        {
          "method": "messagesCount()",
          "description": "Gibt die Anzahl der ausgetauschten Nachrichten zwischen Bot und Nutzer zurück.",
          "code": "RAGAI.INFO.messagesCount();\n"
        }
      ]
    },
    {
      "name": "keyval",
      "data": [
        {
          "method": "set('key', 'value', 'type')",
          "description": "Setzt eine Information (**value**) mit Hilfe eines eindeutigen Schlüssels (**key**). Optional kann ein Typ vergeben werden; wird dieser ausgelassen, ist der Typ standardmäßig „custom“.Der **key** kann mit einem **!** beginnen, um den Wert permanent zu speichern.",
          "code": "await RAGAI.KEYVAL.set('key', 'value', 'userInfo');\n"
        },
        {
          "method": "unique('key', 'value', 'type')",
          "description": "Diese Funktion verhält sich wie die set()-Funktion mit dem Zusatz, dass der Schlüssel einen Zeitstempel angehängt bekommt.",
          "code": "await RAGAI.KEYVAL.set('key', 'value', 'userInfo');\n"
        },
        {
          "method": "get('key')",
          "description": "Gibt den Wert des eingegebenen Schlüssels zurück.",
          "code": "RAGAI.KEYVAL.get('key');\n"
        },
        {
          "method": "getByType('type')",
          "description": "Gibt alle Werte als Array zurück, die dem eingegebenen Typ entsprechen.",
          "code": "RAGAI.KEYVAL.getByType('userInfo');\n"
        },
        {
          "method": "deleteKeyValEntry('key', 'type')",
          "description": "Löscht einen keyval anhand eines Schlüssels (key) und optional des Typs.",
          "code": "await RAGAI.KEYVAL.deleteKeyValEntry('key', 'type')\n"
        }
      ]
    },
    {
      "name": "log",
      "data": [
        {
          "method": "enable(collapsed = true)",
          "description": "Aktiviert das Logging in dem aufgerufenen Bot.",
          "code": "await RAGAI.LOG.enable();\n"
        },
        {
          "method": "disable()",
          "description": "Deaktiviert das Logging in dem aufgerufenen Bot.",
          "code": "await RAGAI.LOG.disable();\n"
        },
        {
          "method": "measureRunStart('prompt')",
          "description": "Miss die Zeit für den angegebenen Prompt.",
          "code": "await RAGAI.LOG.measureRunStart('prompt measuring now!');\n"
        },
        {
          "method": "measureHook('hookName', params)",
          "description": "Miss die Zeit für den angegebenen Hook.",
          "code": "await RAGAI.LOG.measureHook('meinHook', {});\n"
        },
        {
          "method": "measureRunStep('stepName', direction = '', executionDuration = 0)",
          "description": "Gibt die gemessene Zeit für einen Run-Step aus.",
          "code": "await RAGAI.LOG.measureRunStep('step1', 'in', 500);\n"
        },
        {
          "method": "logTimingGraph(duration)",
          "description": "Erstellt einen Graphen auf Basis der verbrauchten Zeit.",
          "code": "await RAGAI.LOG.logTimingGraph(500);\n"
        },
        {
          "method": "measureRunStop()",
          "description": "Stoppt die Zeitmessung von measureRunStart und erzeugt eine Log-Ausgabe.",
          "code": "await RAGAI.LOG.measureRunStop();\n"
        }
      ]
    },
    {
      "name": "mail",
      "data": [
        {
          "method": "getEnvelope('to', 'subject', 'body')",
          "description": "Gibt asynchron die Eingabe als Envelope wieder zurück.",
          "code": "envelope = await RAGAI.MAIL.getEnvelope('max@musterfrau.com','Betreff','Guten Tag...')\n"
        },
        {
          "method": "webhook('webhook', envelope)",
          "description": "Führt einen webhook aus um eine E-Mail zu versenden.",
          "code": "await RAGAI.MAIL.webhook('webhook', envelope)\n"
        }
      ]
    },
    {
      "name": "msg",
      "data": [
        {
          "method": "prompt(text)",
          "description": "Emittiert den eingegebenen Text.",
          "code": "RAGAI.MSG.prompt('Sei freundlich zum Nutzer');\n"
        },
        {
          "method": "overwriteSystemPrompt(prompt)",
          "description": "Überschreibt den ursprünglichen Systemprompt des Bots.",
          "code": "RAGAI.MSG.overwriteSystemPrompt('Sei freundlich zum Nutzer');\n"
        },
        {
          "method": "userMessage(text)",
          "description": "Fügt eine Nachricht aus Nutzersicht zum Chat hinzu.",
          "code": "RAGAI.MSG.userMessage('Sag mir mehr zum Thema XYZ');\n"
        },
        {
          "method": "botMessage(text)",
          "description": "Fügt eine Nachricht aus Botsicht zum Chat hinzu.",
          "code": "RAGAI.MSG.botMessage('Hier sind weitere Informationen zu XYZ: Link');\n"
        },
        {
          "method": "botBypass(text)",
          "description": "Fügt eine unsichtbare Nachricht aus Botsicht zum Chat hinzu, auf die der Bot nicht antwortet.",
          "code": "RAGAI.MSG.botBypass('Hier sind weitere Informationen zu XYZ: Link');\n"
        },
        {
          "method": "userBypass(text)",
          "description": "Fügt eine unsichtbare Nachricht aus Nutzersicht zum Chat hinzu, der Bot wird darauf nicht antworten.",
          "code": "RAGAI.MSG.userBypass('Nutzer interessiert sich für: XYZ');\n"
        }
      ]
    },
    {
      "name": "overlay",
      "data": [
        {
          "method": "text('text')",
          "description": "Zeigt den Text in einem Overlay an.",
          "code": "RAGAI.OVERLAY.text('Ich bin ein Text');\n"
        },
        {
          "method": "button(buttonConfig[])",
          "description": "Zeigt ein Overlay mit interaktiven Schaltflächen an.",
          "code": "RAGAI.OVERLAY.button(\n  [\n    {text:'ja',className:'btn btn-primary',onClick:function(){}},\n    {text:'nein',className:'btn btn-primary',onClick:function(){}},\n  ]\n);\n"
        },
        {
          "method": "textAndButton('text', buttonConfig[])",
          "description": "Zeigt ein Overlay mit Text und interaktiven Schaltflächen an.",
          "code": "RAGAI.OVERLAY.textAndButton('text',\n  [\n    {text:'ja',className:'btn btn-primary',onClick:function(){}},\n    {text:'nein',className:'btn btn-primary',onClick:function(){}},\n  ]\n);\n"
        },
        {
          "method": "html('html')",
          "description": "Zeigt ein Overlay mit interpretierten HTML an.",
          "code": "RAGAI.OVERLAY.html('<h1>HTML Overlay</h1>');\n"
        },
        {
          "method": "loading('text')",
          "description": "Zeigt ein Overlay mit einer Ladeanimation und einem Text an.",
          "code": "RAGAI.OVERLAY.loading('Wird geladen ...');\n"
        },
        {
          "method": "prompt('text', buttonConfig[])",
          "description": "Zeigt ein Overlay mit einem Eingabefeld für einen Prompt an.",
          "code": "RAGAI.OVERLAY.prompt('Du bist jetzt freundlich',\n  [\n    {text:'ja',className:'btn btn-primary',onClick:function(){}},\n    {text:'nein',className:'btn btn-primary',onClick:function(){}},\n  ]);\n"
        },
        {
          "method": "promptArea('text', buttonConfig[])",
          "description": "Zeigt ein Overlay mit einem großen Eingabefeld für einen Prompt an.",
          "code": "RAGAI.OVERLAY.promptArea('Du bist jetzt freundlich',\n  [\n    {text:'ja',className:'btn btn-primary',onClick:function(){}},\n    {text:'nein',className:'btn btn-primary',onClick:function(){}},\n  ]);\n"
        },
        {
          "method": "uploadImage('title', 'instruction', onImageLoaded_function)",
          "description": "Zeigt ein Overlay mit einem Eingabefeld und einer Möglichkeit, ein Bild hochzuladen, an.",
          "code": "RAGAI.OVERLAY.uploadImage('Bild-Upload', 'Analysiere das folgende Bild', ('content', 'name', 'type') => {});\n"
        },
        {
          "method": "uploadFile('title', 'instruction', onFileLoaded_function)",
          "description": "Zeigt ein Overlay mit einem Eingabefeld und einer Möglichkeit, eine Datei hochzuladen, an.",
          "code": "RAGAI.OVERLAY.uploadFile('Datei-Upload', 'Analysiere die folgende Datei', ('content', 'name', 'type') => {});\n"
        },
        {
          "method": "stageList('text')",
          "description": "Zeigt ein Overlay mit allen eingestellten Stages und optionalem Text an.",
          "code": "RAGAI.OVERLAY.stageList('Ich bin ein Text');\n"
        },
        {
          "method": "stageChangeDialog('text')",
          "description": "Zeigt ein Overlay mit allen eingestellten Stages bis auf die aktuell eingestellte Stage und optionalem Text an.",
          "code": "RAGAI.OVERLAY.stageChangeDialog('Ich bin ein Text');\n"
        },
        {
          "method": "uploadImage('title', 'instruction, callback(base64image))",
          "description": "Zeigt ein Overlay mit einem Datei-Upload für Bilder. Nach der Bildauswahl wir im Callback das Bild als base64string weitergegeben.",
          "code": "RAGAI.OVERLAY.uploadImage('Bild zur Analyse auswählen', 'Bild hierher ziehen (PNG, JPEG, WEBP, Non-animated GIF)', async function passImage(base64image) {\n\n});\n"
        },
        {
          "method": "close()",
          "description": "Schließt das bestehende individuelle Overlay.",
          "code": "RAGAI.OVERLAY.close();\n"
        },
        {
          "method": "prompt_getInput()",
          "description": "Gibt das HTML-Element des Eingabefeldes der promptArea zurück.",
          "code": "RAGAI.OVERLAY.prompt_getInput();\n"
        },
        {
          "method": "fileUpload_getTextArea()",
          "description": "Gibt das HTML-Element des Eingabefeldes des uploadFile zurück.",
          "code": "RAGAI.OVERLAY.fileUpload_getTextArea();\n"
        },
        {
          "method": "fileUpload_getValue()",
          "description": "Gibt den Wert des Eingabefeldes des uploadFile zurück.",
          "code": "RAGAI.OVERLAY.fileUpload_getValue();\n"
        },
        {
          "method": "prompt_getInputValue()",
          "description": "Gibt den Wert des Eingabefeldes der promptArea zurück.",
          "code": "RAGAI.OVERLAY.prompt_getInputValue();\n"
        }
      ]
    },
    {
      "name": "promptbar",
      "data": [
        {
          "method": "promptBarBehavior",
          "description": "Eine String-Variable, die entweder 'runMessage' oder 'userMessage' akzeptiert. Die Variable steuert das Verhalten der Chat-Promptbar, also ob eingegebene Inhalte an eine KI geleitet werden sollen ('userMessage') oder nicht ('runMessage').",
          "code": "console.log(RAGAI.PROMPTBAR.promptBarBehavior);\n"
        }
      ]
    },
    {
      "name": "quiz",
      "data": [
        {
          "method": "IS_RUNNING()",
          "description": "Boolean, ob aktuell ein Quiz besteht",
          "code": "RAGAI.QUIZ.IS_RUNNING();\n"
        },
        {
          "method": "QUESTIONS_UPCOMMING()",
          "description": "Anzahl der Fragen im Quiz",
          "code": "RAGAI.QUIZ.QUESTIONS_UPCOMMING();\n"
        },
        {
          "method": "ASKED_QUESTIONS()",
          "description": "Anzahl der bereits gestellten Fragen im Quiz",
          "code": "RAGAI.QUIZ.ASKED_QUESTIONS();\n"
        },
        {
          "method": "ANSWERED_QUESTIONS()",
          "description": "Anzahl der bereits beantworteten Fragen im Quiz",
          "code": "RAGAI.QUIZ.ANSWERED_QUESTIONS();\n"
        },
        {
          "method": "CURRENT_QUESTION_NUMBER()",
          "description": "Aktuelle Position im Quiz",
          "code": "RAGAI.QUIZ.CURRENT_QUESTION_NUMBER();\n"
        },
        {
          "method": "LOADING_MSG",
          "description": "String für die Ladenachricht zum Start des Quiz",
          "code": "RAGAI.QUIZ.LOADING_MSG = 'Quiz wird vorbereitet...';\n"
        },
        {
          "method": "debug(eventData)",
          "description": "Debug-Methode, die ein beliebiges JSON entgegennimmt und in eine Card setzt",
          "code": "RAGAI.QUIZ.debug({});\n"
        },
        {
          "method": "end()",
          "description": "Triggert das Ende-Event im Quiz",
          "code": "RAGAI.QUIZ.end();\n"
        },
        {
          "method": "cleanupQuiz()",
          "description": "Setzt das aktuelle Quiz zurück",
          "code": "RAGAI.QUIZ.cleanupQuiz();\n"
        },
        {
          "method": "startFromText(source)",
          "description": "Startet ein Quiz mit dem angegebenen Text",
          "code": "await RAGAI.QUIZ.startFromText('');\n"
        },
        {
          "method": "nextQuestion()",
          "description": "Führt entweder das Ende des Quiz oder die nächste Frage aus",
          "code": "await RAGAI.QUIZ.nextQuestion();\n"
        },
        {
          "method": "getQuestionsFromText(t)",
          "description": "Führt mit den angegebenen Text eine Completion aus, dessen Resultat die Fragen mit Lösungen beinhaltet",
          "code": "await RAGAI.QUIZ.getQuestionsFromText('');\n"
        },
        {
          "method": "showAnswerOptions(curr)",
          "description": "Stellt im Chat ein Quiz-Objekt mit der Frage und Antwortmöglichkeiten dar.",
          "code": "const curr = {\n  q: string;\n  r: string;\n  w: string[];\n}\nawait RAGAI.QUIZ.showAnswerOptions(curr);\n"
        }
      ]
    },
    {
      "name": "score",
      "data": [
        {
          "method": "get()",
          "description": "Gibt den aktuellen Score zurück.",
          "code": "RAGAI.SCORE.get();\n"
        },
        {
          "method": "reset()",
          "description": "Setzt den aktuellen Score zurück.",
          "code": "RAGAI.SCORE.reset();\n"
        },
        {
          "method": "set(number)",
          "description": "Setzt den aktuellen Score auf die angegebene Punktzahl.",
          "code": "RAGAI.SCORE.set(1);\n"
        },
        {
          "method": "sub(number)",
          "description": "Verringert den aktuellen Score um die angegebene Punktzahl.",
          "code": "RAGAI.SCORE.sub(1);\n"
        },
        {
          "method": "achieve(number, 'skillId', 'message', autoMessage = false)",
          "description": "Archiviert einen Erfolg.",
          "code": "RAGAI.SCORE.achieve();\n"
        },
        {
          "method": "getAchieveMents(asJson = false)",
          "description": "Holt die SCORE Achievements als JSON oder Text.",
          "code": "var achieve = RAGAI.SCORE.getAchieveMents();\n"
        },
        {
          "method": "db('DB_NAME').get()",
          "description": "Gibt aus der Datenbank 'DB_NAME' den aktuellen Score zurück.",
          "code": "RAGAI.SCORE.db('DB_NAME').get();\n"
        },
        {
          "method": "db('DB_NAME').reset()",
          "description": "Setzt in der Datenbank 'DB_NAME' den aktuellen Score zurück.",
          "code": "RAGAI.SCORE.db('DB_NAME').reset();\n"
        },
        {
          "method": "db('DB_NAME').set()",
          "description": "Setzt in der Datenbank 'DB_NAME' den aktuellen Score auf die angegebene Punktzahl.",
          "code": "RAGAI.SCORE.db('DB_NAME').set();\n"
        },
        {
          "method": "db('DB_NAME').achieve(number, 'skillId', 'message', autoMessage = false)",
          "description": "Archiviert in der Datenbank 'DB_NAME' einen Erfolg.",
          "code": "RAGAI.SCORE.db('DB_NAME').achieve();\n"
        },
        {
          "method": "db('DB_NAME').sub()",
          "description": "Verringert in der Datenbank 'DB_NAME' den aktuellen Score um die angegebene Punktzahl.",
          "code": "RAGAI.SCORE.db('DB_NAME').sub();\n"
        },
        {
          "method": "db('DB_NAME').getAchieveMents()",
          "description": "Holt aus der Datenbank 'DB_NAME' die SCORE Achievements als JSON oder Text.",
          "code": "var achieve = RAGAI.SCORE.db('DB_NAME').getAchieveMents();\n"
        }
      ]
    },
    {
      "name": "scorm",
      "data": [
        {
          "method": "LMSSetValue('key', 'value')",
          "description": "Setzt mittels eines eindeutigen Schlüssels einen Wert im LMS.",
          "code": "await RAGAI.SCORM.LMSSetValue('cmi.core.lesson_status', 'STATUS');\n"
        },
        {
          "method": "LMSGetValue('key')",
          "description": "Holt einen Wert über einen Schlüssel aus dem LMS.",
          "code": "await RAGAI.SCORM.LMSGetValue('cmi.core.lesson_status');\n"
        },
        {
          "method": "scormHook('hook', params)",
          "description": "Erstellt ein Hook auf das LMS mit beliebigen Parametern.",
          "code": "RAGAI.SCORM.scormHook('bestehenHook', { format: 'json'});\n"
        }
      ]
    },
    {
      "name": "skill",
      "data": [
        {
          "method": "enableSkills(skills[])",
          "description": "Aktiviert einen oder mehrere Skills für die aktuelle Chat-Session.",
          "code": "await RAGAI.SKILL.enableSkills(['skillId1','skillId2']);\n"
        },
        {
          "method": "disableSkills(skills[])",
          "description": "Deaktiviert einen oder mehrere Skills für die aktuelle Chat-Session.",
          "code": "await RAGAI.SKILL.disableSkills(['skillId1','skillId2']);\n"
        },
        {
          "method": "enableSkillAndChildren('skill', depth)",
          "description": "Aktiviert den Skill und alle Kinder bis zur Tiefe 2.",
          "code": "await RAGAI.SKILL.enableSkillAndChildren('SKILL_ID', 2);\n"
        },
        {
          "method": "disableSkillAndChildren('skill', depth)",
          "description": "Deaktiviert den Skill und alle Kinder bis zur Tiefe 2.",
          "code": "await RAGAI.SKILL.disableSkillAndChildren('SKILL_ID', 2);\n"
        },
        {
          "method": "skillsForNextRun(skills[])",
          "description": "Die angegebenen SkillIDs werden forciert an die KI übergeben.",
          "code": "await RAGAI.SKILL.skillsForNextRun(['skillId1','skillId2']);\n"
        },
        {
          "method": "unforceAllSkills()",
          "description": "Die Forcierung aller Skills wird aufgehoben.",
          "code": "await RAGAI.SKILL.unforceAllSkills();\n"
        },
        {
          "method": "getSkills()",
          "description": "Gibt alle verfügbaren Skills des Bots zurück.",
          "code": "await RAGAI.SKILL.getSkills();\n"
        },
        {
          "method": "disableAllSkills()",
          "description": "Deaktiviert alle Skills für die aktuelle Chat-Session.",
          "code": "await RAGAI.SKILL.disableAllSkills();\n"
        },
        {
          "method": "getSkillIdChildren('skill', depth)",
          "description": "Gibt alle verfügbaren Kinder des Skills im Bot bis zur angegebenen Tiefe zurück.",
          "code": "await RAGAI.SKILL.getSkillIdChildren('SKILL_ID', 2);\n"
        },
        {
          "method": "getSkillDepth('skill')",
          "description": "Gibt die Tiefe eines gegebenen Skills zurück.",
          "code": "await RAGAI.SKILL.getSkillDepth('SKILL_ID');\n"
        },
        {
          "method": "getSkillPath('skill')",
          "description": "Unterteilt einen Skill auf Basis von enthaltenen Zahlen in ein string-Array.",
          "code": "await RAGAI.SKILL.getSkillPath('skillId');\n"
        },
        {
          "method": "getTreeFromSkillIds(skills[])",
          "description": "Extrahiert aus skillIdsToTreeItems() die obersten Skills.",
          "code": "await RAGAI.SKILL.getTreeFromSkillIds(['skillId1','skillId2']);\n"
        },
        {
          "method": "skillIdsToTreeItems(skills[])",
          "description": "Erstellt mit den angegebenen Skills eine Baumstruktur.",
          "code": "await RAGAI.SKILL.skillIdsToTreeItems(['skillId1','skillId2']);\n"
        }
      ]
    },
    {
      "name": "stage",
      "data": [
        {
          "method": "add('name', 'stage')",
          "description": "Fügt eine neue Stage hinzu.",
          "code": "RAGAI.STAGE.add('Start');\n"
        },
        {
          "method": "remove('name')",
          "description": "Löscht die angegebene Stage.",
          "code": "RAGAI.STAGE.remove('Start');\n"
        },
        {
          "method": "hide('name')",
          "description": "Verbirgt die angegebene Stage.",
          "code": "RAGAI.STAGE.hide('Start');\n"
        },
        {
          "method": "show('name')",
          "description": "Zeigt die angegebene Stage an.",
          "code": "RAGAI.STAGE.show('Start');\n"
        },
        {
          "method": "goToIndex('number')",
          "description": "Setzt die aktuelle Stage auf Basis der angegebenen Array-Position.",
          "code": "RAGAI.STAGE.goToIndex(0);\n"
        },
        {
          "method": "goTo('number' | 'name')",
          "description": "Setzt die aktuelle Stage auf Basis der angegebenen Array-Position oder des Namens.",
          "code": "RAGAI.STAGE.goTo('Start');\n"
        },
        {
          "method": "goToRandom(string[])",
          "description": "Setzt die aktuelle Stage zufällig auf Basis des angegebenen Arrays an Stage-Namen oder aller verfügbaren Stages.",
          "code": "RAGAI.STAGE.goToRandom(['Start', 'Ende']);\n"
        },
        {
          "method": "goToName('name')",
          "description": "Setzt die aktuelle Stage auf Basis des angegebenen Namens.",
          "code": "RAGAI.STAGE.goToName('Start');\n"
        },
        {
          "method": "next()",
          "description": "Setzt die aktuelle Stage auf die nächstfolgende Stage relativ zur aktuellen.",
          "code": "RAGAI.STAGE.next();\n"
        },
        {
          "method": "prev()",
          "description": "Setzt die aktuelle Stage auf die vorherige Stage relativ zur aktuellen.",
          "code": "RAGAI.STAGE.prev();\n"
        },
        {
          "method": "allStages",
          "description": "Gibt alle aktuell eingetragenen Stages wieder.",
          "code": "RAGAI.STAGE.allStages;\n"
        },
        {
          "method": "visibleStages",
          "description": "Gibt alle aktuell eingetragenen und sichtbaren Stages zurück.",
          "code": "RAGAI.STAGE.visibleStages;\n"
        },
        {
          "method": "restore()",
          "description": "Stellt die zuletzt verwendete Stage wieder her.",
          "code": "RAGAI.STAGE.restore();\n"
        },
        {
          "method": "list()",
          "description": "Gibt die Namen aller Stages zurück.",
          "code": "RAGAI.STAGE.list();\n"
        }
      ]
    },
    {
      "name": "supervisor",
      "data": [
        {
          "method": "notify('messageName', 'historyItemId')",
          "description": "Löst eine Benachrichtigung an den Supervisor aus.",
          "code": "await RAGAI.SUPERVISOR.notify('Kontaktaufnahme gewünscht', conf.triggerHistoryItemId);\n"
        },
        {
          "method": "setInfo('key', 'value')",
          "description": "Setzt für den Supervisor eine Information (value) mittels eines eindeutigen Schlüssels (key).",
          "code": "RAGAI.SUPERVISOR.setInfo('key', 'value');\n"
        },
        {
          "method": "getInfo('key')",
          "description": "Ruft für den Supervisor eine Information (value) mittels eines eindeutigen Schlüssels (key) ab.",
          "code": "await RAGAI.SUPERVISOR.getInfo('key');\n"
        }
      ]
    },
    {
      "name": "toastr",
      "data": [
        {
          "method": "success(Nachricht, Titel, Optionen)",
          "description": "Es wird eine grüne Benachrichtigungsbox mit der eingegebenen Nachricht sowie optionalem Titel und Optionen angezeigt.",
          "code": "RAGAI.toastr.success('Dies war erfolgreich', 'Erfolg');\n"
        },
        {
          "method": "error(Nachricht, Titel, Optionen)",
          "description": "Es wird eine rote Benachrichtigungsbox mit der eingegebenen Nachricht sowie optionalem Titel und Optionen angezeigt.",
          "code": "RAGAI.toastr.error('Es gab einen Fehler', 'Fehler');\n"
        },
        {
          "method": "info(Nachricht, Titel, Optionen)",
          "description": "Es wird eine blaue Benachrichtigungsbox mit der eingegebenen Nachricht sowie optionalem Titel und Optionen angezeigt.",
          "code": "RAGAI.toastr.info('Dies ist eine Information', 'Information');\n"
        },
        {
          "method": "warning(Nachricht, Titel, Optionen)",
          "description": "Es wird eine gelb-orange Benachrichtigungsbox mit der eingegebenen Nachricht sowie optionalem Titel und Optionen angezeigt.",
          "code": "RAGAI.toastr.warning('Dies ist eine Warnung', 'Warnung');\n"
        }
      ]
    },
    {
      "name": "train",
      "data": [
        {
          "method": "registerCourse('courseId')",
          "description": "Registriert für den Nutzer einen Kurs im Train-System.",
          "code": "await RAGAI.TRAIN.registerCourse('asdfg76JHUI6dsafuz');\n"
        }
      ]
    },
    {
      "name": "video_avatar",
      "data": [
        {
          "method": "setBackgroundImage('source')",
          "description": "Setzt anhand der übergebenen Quelle (Skill-ID oder Bild-URL) das Hintergrundbild für den Avatar.",
          "code": "await RAGAI.VIDEO_AVATAR.setBackgroundImage('source');\n"
        },
        {
          "method": "unsetImage()",
          "description": "Entfernt das gesetzte Hintergrundbild für den Avatar und wechselt zum Standard-Hintergrundbild.",
          "code": "await RAGAI.VIDEO_AVATAR.unsetImage();\n"
        },
        {
          "method": "getBackgroundImage()",
          "description": "Gibt das aktuell gesetzte Hintergrundbild zurück.",
          "code": "await RAGAI.VIDEO_AVATAR.getBackgroundImage();\n"
        },
        {
          "method": "stop()",
          "description": "Bricht das Bot-Denken sowie eine laufende Sprachausgabe des Avatars ab (Barge-in).",
          "code": "await RAGAI.VIDEO_AVATAR.stop();\n"
        }
      ]
    },
    {
      "name": "vimeo",
      "data": [
        {
          "method": "play()",
          "description": "Startet die Video-Wiedergabe.",
          "code": "RAGAI.VIMEO.play();\n"
        },
        {
          "method": "pause()",
          "description": "Pausiert die Video-Wiedergabe.",
          "code": "RAGAI.VIMEO.pause();\n"
        },
        {
          "method": "currentPlayPosition()",
          "description": "Gibt die aktuelle Stelle im Video wieder.",
          "code": "RAGAI.VIMEO.currentPlayPosition();\n"
        },
        {
          "method": "seekTo(hours, minutes, seconds)",
          "description": "Springt an die angegebene Stelle im Video.",
          "code": "RAGAI.VIMEO.setCurrentTime(0, 0, 7);\n"
        },
        {
          "method": "setVolume(volume)",
          "description": "Ändert die Lautstärke des Videos.",
          "code": "RAGAI.VIMEO.setVolume(100);\n"
        },
        {
          "method": "setPlaybackRate(playbackRate)",
          "description": "Ändert die Wiedergabegeschwindigkeit des Videos.",
          "code": "RAGAI.VIMEO.setVolume(1.5);\n"
        },
        {
          "method": "getColors()",
          "description": "Gibt die aktuellen Farben des Players wieder.",
          "code": "RAGAI.VIMEO.getColors();\n"
        },
        {
          "method": "setColors(colors: [Primary, Accent, Text/Icon, Background])",
          "description": "Setzt die Farben des Players. Es können hexadezimal oder RGB verwendet werden.",
          "code": "RAGAI.VIMEO.setColors(['#000000', '#00adef', '#ffffff', '#000000']);\n"
        },
        {
          "method": "loadVideo(id | url | object)",
          "description": "Lädt ein anderes Video in den Player.",
          "code": "RAGAI.VIMEO.loadVideo(347119375);\n"
        }
      ]
    },
    {
      "name": "waitfor",
      "data": [
        {
          "method": "initialIdle()",
          "description": "Diese Funktion wartet darauf, dass der Bot seine Initialisierung abgeschlossen hat und sich im Ruhezustand befindet. Erst danach ist der Bot vollständig bereit, RAGAI-Befehle entgegenzunehmen.",
          "code": "await RAGAI.WAITFOR.initialIdle();\n"
        },
        {
          "method": "nextIdle()",
          "description": "Diese Funktion wartet darauf, dass der Bot das nächste Mal in den Status Idle wechselt. Danach ist dann z. B. der Bot fertig mit Schreiben.",
          "code": "await RAGAI.WAITFOR.nextIdle();\n"
        },
        {
          "method": "varsInit()",
          "description": "Wartet darauf, dass der Score und keyvalstorage geladen werden.",
          "code": "await RAGAI.WAITFOR.varsInit();\n"
        },
        {
          "method": "event(hook)",
          "description": "Wartet darauf, dass ein Hook auf Basis der übergebenen Hook-ID ausgeführt wurde.",
          "code": "await RAGAI.WAITFOR.event('overlay_geschlossen');\n"
        },
        {
          "method": "minutes(x)",
          "description": "Anzahl an Minuten, die gewartet werden soll.",
          "code": "await RAGAI.WAITFOR.minutes(5);\n"
        },
        {
          "method": "seconds(x)",
          "description": "Anzahl an Sekunden, die gewartet werden soll.",
          "code": "await RAGAI.WAITFOR.seconds(5);\n"
        }
      ]
    },
    {
      "name": "webhook",
      "data": [
        {
          "method": "call('skillId', data)",
          "description": "Ruft einen Webhook mit den übergebenen Daten auf.",
          "code": "await RAGAI.WEBHOOK.call('meinWebhook', { 'value1': '', 'value2': '', 'value3': '' });\n"
        }
      ]
    },
    {
      "name": "youtube",
      "data": [
        {
          "method": "play()",
          "description": "Startet die Video-Wiedergabe.",
          "code": "RAGAI.YOUTUBE.play();\n"
        },
        {
          "method": "pause()",
          "description": "Pausiert die Video-Wiedergabe.",
          "code": "RAGAI.YOUTUBE.pause();\n"
        },
        {
          "method": "stop()",
          "description": "Stoppt die Video-Wiedergabe.",
          "code": "RAGAI.YOUTUBE.stop();\n"
        },
        {
          "method": "mute()",
          "description": "Schaltet die Audio-Ausgabe des Videos aus.",
          "code": "RAGAI.YOUTUBE.mute();\n"
        },
        {
          "method": "unmute()",
          "description": "Schaltet die Audio-Ausgabe des Videos ein.",
          "code": "RAGAI.YOUTUBE.unmute();\n"
        },
        {
          "method": "setPlaybackRate(rate)",
          "description": "Stellt die Wiedergabegeschwindigkeit des Videos ein.",
          "code": "RAGAI.YOUTUBE.setPlaybackRate(1.5);\n"
        },
        {
          "method": "setVolume(volume)",
          "description": "Stellt die Lautstärke des Videos ein.",
          "code": "RAGAI.YOUTUBE.setVolume(37);\n"
        },
        {
          "method": "seekTo(hours, minutes, seconds, allowSeekAhead = true)",
          "description": "Springt an die angegebene Stelle im Video.",
          "code": "RAGAI.YOUTUBE.seekTo(0, 0, 5, false);\n"
        },
        {
          "method": "loadVideo(videoId, startSeconds, endSeconds)",
          "description": "Lädt ein anderes Youtube-Video auf Basis der eingegebenen ID mit optionalen Start- & Endpunkt für die Wiedergabe.",
          "code": "RAGAI.YOUTUBE.loadVideo('YT_VIDEO_ID', 3);\n"
        }
      ]
    }
  ],
  "botapi": [
    {
      "method": "botApiQuerySelector('iframe_elem_id', debug = false)",
      "description": "Erstellt und gibt eine Schnittstelle für din angegebenen CSS-Selektor des HTML-IFrame-Elements zurück. Die Funktion kann mehrfach mit verschiedenen CSS-Selektoren aufgerufen werden.",
      "code": "await botApiQuerySelector('bot-iframe');\n"
    },
    {
      "method": "botApi('iframe_elem_id', debug = false)",
      "description": "Erstellt und gibt eine Schnittstelle für die angegebene ID des HTML-IFrame-Element zurück. Die Funktion kann mehrfach mit verschiedenen IFrame-IDs aufgerufen werden.",
      "code": "await botApi('bot-iframe');\n"
    },
    {
      "method": ".waitForInitialIdle()",
      "description": "Diese Funktion wartet darauf, dass der Bot seine Initialisierung abgeschlossen hat und sich im Ruhezustand befindet. Erst danach ist der Bot vollständig bereit, RAGAI-Befehle entgegenzunehmen.",
      "code": "await botApi.waitForInitialIdle();\n"
    },
    {
      "method": ".waitForNextIdle()",
      "description": "Diese Funktion wartet darauf, dass der Bot das nächste mal in den Status Idle wechselt. Danach ist dann z.B. der Bot fertig mit Schreiben.",
      "code": "await botApi.waitForNextIdle();\n"
    },
    {
      "method": ".eventStream('eventName', args[])",
      "description": "Hier werden der erfasste Eventname und die übermittelten Optionen emittiert.",
      "code": "await botApi.eventStream('');\n"
    },
    {
      "method": ".registerCourse()",
      "description": "Registriert für den Nutzer einen Kurs im Train-System.",
      "code": "await botApi.registerCourse('asdfg76JHUI6dsafuz');\n"
    },
    {
      "method": ".unRegisterExternalFunction('functionName', function())",
      "description": "Entfernt eine zuvor registrierte, dem IFrame gegenüber externe JS-Funktion.",
      "code": "await botApi.unRegisterExternalFunction('echo', () => { console.log('echo');});\n"
    },
    {
      "method": ".registerExternalFunction('functionName', function())",
      "description": "Registriert eine dem IFrame fremde JS-Funktion.",
      "code": "await botApi.registerExternalFunction('echo', () => { console.log('echo');});\n"
    },
    {
      "method": ".callExternalFunction('functionName', args[])",
      "description": "Aufruf einer dem IFrame fremden JS-Funktion.",
      "code": "await botApi.callExternalFunction('echo', []);\n"
    },
    {
      "method": ".getScormApi()",
      "description": "Emittiert die Schnittstelle für eine SCORM-Kommunikation zurück.",
      "code": "await botApi.getScormApi();\n"
    },
    {
      "method": ".userMessage('message')",
      "description": "Emittiert eine Nachricht aus Nutzersicht an das IFrame.",
      "code": "await botApi.userMessage('Hello Bot')\n"
    },
    {
      "method": ".userBypass('message')",
      "description": "Sendet eine Nachricht aus Nutzersicht an die KI.",
      "code": "await botApi.userBypass('Secret Message to Bot');\n"
    },
    {
      "method": ".botMessage('message')",
      "description": "Emittiert eine Nachricht aus Botsicht an das IFrame.",
      "code": "await botApi.botMessage('Hello User');\n"
    },
    {
      "method": ".botBypass('message')",
      "description": "Sendet eine Nachricht aus Botsicht an den Nutzer.",
      "code": "await botApi.botBypass('Secret Message to User');\n"
    },
    {
      "method": ".runMessage('message')",
      "description": "Emittiert eine Nachricht an das IFrame.",
      "code": "await botApi.runMessage('Hello Bot');\n"
    },
    {
      "method": ".botSay('message', 'voice')",
      "description": "Lässt eine Nachricht als Audio ausgeben.",
      "code": "await botApi.botSay();\n"
    },
    {
      "method": ".youtubeCard('video_id')",
      "description": "Zeigt ein YouTube-Video direkt im Chatverlauf an.",
      "code": "await botApi.youtubeCard();\n"
    },
    {
      "method": ".vimeoCard('video_id')",
      "description": "Zeigt ein Vimeo-Video direkt im Chatverlauf an.",
      "code": "await botApi.vimeoCard();\n"
    },
    {
      "method": ".iframeCard('url')",
      "description": "Zeigt eine eingebettete Website als iFrame direkt im Chatverlauf an.",
      "code": "await botApi.iframeCard();\n"
    },
    {
      "method": ".confetti()",
      "description": "Lässt Konfetti im IFrame anzeigen.",
      "code": "await botApi.confetti()\n"
    }
  ]
}